import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import { Dropdown, } from 'semantic-ui-react';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const MobileNav = ({ elmId, className, children, selection = true, fluid = true, ...rest }) => {
    return (_jsx(Dropdown, { className: cx('mobile-nav', className), id: elmId, selection: selection, fluid: fluid, ...rest, children: children }));
};
const MobileNavWithStatics = MobileNav;
MobileNavWithStatics.Divider = Dropdown.Divider;
MobileNavWithStatics.Header = Dropdown.Header;
MobileNavWithStatics.Item = Dropdown.Item;
MobileNavWithStatics.Menu = Dropdown.Menu;
MobileNavWithStatics.SearchInput = Dropdown.SearchInput;
export default MobileNavWithStatics;
//# sourceMappingURL=index.js.map